import React from 'react';
import {useParams} from 'react-router';
import {useTariff} from 'contexts/Tariff';
import ArrowRight from 'components/ui/icon/ArrowRight';
import Container from 'components/layout/Container';
import {TARIFFS} from 'data/tariffs';
import formatNumber from 'utils/formatNumber';
import pluralize from 'utils/pluralize';
import {useAnalytics} from 'contexts/Analytics';

import './Continue.scss';

const Continue = () => {
  const {slug} = useParams();
  const {handleEvent} = useAnalytics();
  const tariffAPI = useTariff();
  const tariff = TARIFFS[slug];
  const tariffName = tariff?.name?.toLowerCase();
  const chosenServices = tariffAPI.getSupplements(slug);
  const hasChosenServices = chosenServices.length > 0;
  const supplementCummulativePrice = (
    hasChosenServices ? chosenServices : []
  ).reduce((prev, curr) => curr.price + prev, 0);
  const totalPrice =
    tariffAPI.tariffState.squareMeters * (tariff?.price || 0) +
    supplementCummulativePrice;
  const isCustomTariff = slug === 'custom';

  return (
    <div className="continue">
      <Container extraClassName="continue__wrapper">
        <div className="continue_left">
          {!!slug && totalPrice > 0 && (
            <div className="continue__superscript">
              Ваш {tariffName} ремонт — {formatNumber(totalPrice)}{' '}
              {pluralize(totalPrice, 'рубль', 'рубля', 'рублей')}
            </div>
          )}

          {!slug && (
            <div className="continue__subscript">
              Если не&nbsp;знаете, какой тариф вам подходит, просто отправьте
              заявку. Мы&nbsp;перезвоним вам в&nbsp;течение нескольких минут,
              обсудим вашу задачу, ответим на&nbsp;вопросы, поможет сделать
              оптимальный выбор.
            </div>
          )}

          {!!slug && hasChosenServices && (
            <div className="continue__subscript continue__subscript_visible">
              {pluralize(
                chosenServices.length,
                'Выбрана',
                'Выбраны',
                'Выбрано',
              )}{' '}
              {chosenServices.length}{' '}
              {!isCustomTariff &&
                pluralize(
                  chosenServices.length,
                  'дополнительная ',
                  'дополнительные ',
                  'дополнительных ',
                )}
              {pluralize(chosenServices.length, 'работа', 'работы', 'работ')}
            </div>
          )}

          {!!slug && !hasChosenServices && (
            <div className="continue__subscript">
              Можете пропустить выбор работ и описать что нужно сделать своими
              словами. Или просто отправить номер телефона, мы перезвоним и
              обсудим вашу задачу.
            </div>
          )}
        </div>

        <div className="continue_right">
          <a
            className="continue__button"
            href="#form"
            onClickCapture={handleEvent('continue_button_click')}
          >
            {!!slug && !hasChosenServices ? 'К заявке' : 'Отправить заявку'}{' '}
            <ArrowRight color="#fff" />
          </a>
        </div>
      </Container>
    </div>
  );
};

export default Continue;
